import { Alert, Flex } from 'antd';
import { Subtitle, Text } from 'components/mvp-typography';
import { paths } from 'routes';

interface EmptyBalanceAlertWithPayLinkProps {
  assessmentType: string;
}

export function EmptyBalanceAlertWithPayLink(
  props: EmptyBalanceAlertWithPayLinkProps
) {
  return (
    <Flex align="center" vertical>
      <Alert
        type="warning"
        showIcon
        message={<Subtitle>Zero balance</Subtitle>}
        description={
          <Flex vertical gap={16}>
            <Text>
              Your balance for the <b>{props.assessmentType}</b> assessment is
              0. In the next step you will be asked to confirm if you want to
              pay for this single assessment.
            </Text>
            <Text>
              Not sure what this means?{' '}
              <a href={paths.clinician.organisationUsage()}>
                Click here to view your balance and billing.
              </a>
            </Text>
          </Flex>
        }
        style={{
          maxWidth: 500
        }}
      />
    </Flex>
  );
}
